export const API = 'https://api.wire.foundation/hackathon'
// export const API = 'http://localhost:3000/hackathon'

export const LEGACY_AIRWIRE_API = 'https://api.airwire.io/'
export const HYPERION = "https://hyperwire.wire.foundation/"
export const CHAIN = "https://testnet-00.wire.foundation/"

export const AES_KEY = "hackathon-secret"

// export const IPFS_GATEWAY = "https://ipfs.airwire.io/ipfs/"
export const IPFS_GATEWAY = "https://ipfs.fuego.airwire.io/"
export const IPFS_OG = "https://ipfs.airwire.io/ipfs/"
export const IPFS_SUFFIX = "/image.png"

// export const MATRIX_URL = 'http://localhost:9000'
export const MATRIX_URL = 'https://matrix.wire.foundation'
export const MATRIX = 'matrix.wire.foundation'


export const DEFAULT_SETTINGS: any = {
    dark: true,
}